import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { FarmResponse, FarmUpdateRequest } from "../../schemas";
import {
  createGranularRequestConfig,
  GranularCatalogConfig,
} from "@granular/fabric-catalog-helpers";

const DELETE = async (
  farmId: string,
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  const response = await axios.delete(
    `/api/fields-svc/v2/farm/${farmId}`,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const PUT = async (
  farm: FarmUpdateRequest,
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<FarmResponse>> => {
  const response = await axios.put(
    `/api/fields-svc/v2/farm/${farm.id}`,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  PUT,
  DELETE,
};
